import { useSurveyLocalesStore } from "@stores/survey/surveyLocales";

export const computedAnswerOptions = ({
  answers = [],
  valueType = "code",
  labelField = "title",
  currentValues = undefined,
}) => {
  const surveyLocalesStore = useSurveyLocalesStore();
  const { localizeText } = surveyLocalesStore;
  let options = answers
    ?.map((answer) => computedOption(answer, valueType, labelField, localizeText))
    .filter((option) => option.value != null && option.value !== "");

  if (currentValues) options = addMissingValues(options, currentValues);

  return options;
};

const computedOption = (answer = {}, valueType, labelField, localizeText) => {
  return {
    label: `${answer?.code + "." || ""} ${localizeText(answer?.[labelField]) || answer?.name || "N/A"}`,
    value: answer?.[valueType],
  };
};

const addMissingValues = (options, currentValues) => {
  currentValues.forEach((value) => {
    // Skip empty/null values
    if (value == null || value === "") return;
    if (!options.find((o) => o.value === value)) options.push({ label: "N/A", value, disabled: true });
  });

  return options;
};

//Generate array of objects like [{label: '1', value: '1'}, {label: '2', value: '2'}] from 1 to n
export const computedIntegerListOptions = (start, end, asInteger = false) =>
  Array.from({ length: end - start + 1 }, (_, i) => {
    const value = i + start;
    return { label: value.toString(), value: asInteger ? value : value.toString() };
  });
